import React, {useState, useEffect } from 'react';
import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import { Document, Page, pdfjs } from 'react-pdf';
import { uiCloseModalPdf, uiClearPdfBlob } from '../../actions/uiPdf';
import { downloadBlob } from '../../helpers/downloadDocument';
import './modal.css';
import workerSrc from 'pdfjs-dist/build/pdf.worker.entry';

pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        maxHeight: '90vh',
        overflow: 'auto',
        width: '80%',
    },
};

Modal.setAppElement('#root');

export const PdfPreviewModal = () => {

    const { modalOpenPdf, pdfBlob, pdfFilename } = useSelector(state => state.uiPdf);
    const [numPages, setNumPages] = useState(null);
    const [pdfUrl, setPdfUrl] = useState(null);
    const dispatch = useDispatch();

    useEffect(() => {
        let url;
        if (pdfBlob) {
            url = URL.createObjectURL(pdfBlob);
            setPdfUrl(url);
        }
        return () => {
            if (url) URL.revokeObjectURL(url);
        };
    }, [pdfBlob]);

    const downloadFile = () => {
        if (!pdfBlob) return;
        downloadBlob(pdfUrl, pdfFilename);
    };

    const closeModal = () => {
        dispatch(uiCloseModalPdf());
        dispatch(uiClearPdfBlob());
        setPdfUrl(null);
        setNumPages(null);
    }

    return (
        <Modal
            isOpen={modalOpenPdf}
            onRequestClose={closeModal}
            style={customStyles}
            closeTimeoutMS={200}
            className="modal modal-pdf"
            overlayClassName="modal-fondo"
        >
            <h1 className='title'> Vista previa del PDF </h1>
            <hr />

            <div className="pdf-container" style={{ textAlign: 'center' }}>
            {!pdfUrl ? (
                <p style={{ marginTop: '2rem', color: '#888' }}>⚠️ No se ha especificado ningún archivo PDF.</p>
            ) : (
                <Document
                    file={pdfUrl}
                    onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                    onLoadError={(error) => console.error("Error cargando PDF:", error)}
                >
                {Array.from(new Array(numPages), (el, index) => (
                    <Page key={`page_${index + 1}`} pageNumber={index + 1} scale={1.5}/>
                ))}
                </Document>
            )}
            </div>

            <div className="row justify-content-end mt-3">
                <div className="col-12 d-grid gap-2">
                    {pdfUrl && (
                        <button className="btn btn-secondary" onClick={downloadFile}>
                            Descargar PDF
                        </button>
                    )}
                    <button className="btn btn-outline-danger" onClick={closeModal}>
                        Cerrar
                    </button>
                </div>
            </div>
        </Modal>
    );
};